"use strict";
exports.__esModule = true;
// THIS FILES IS GENERATED USING SCRIPT, DO NOT EDIT DIRECTLY
var margin = function (value) {
    return {
        marginTop: value,
        marginBottom: value,
        marginLeft: value,
        marginRight: value
    };
};
var padding = function (value) {
    return {
        paddingTop: value,
        paddingBottom: value,
        paddingLeft: value,
        paddingRight: value
    };
};
var borderRadius = function (value) {
    return {
        borderTopLeftRadius: value,
        borderTopRightRadius: value,
        borderBottomLeftRadius: value,
        borderBottomRightRadius: value
    };
};
var borderWidth = function (value) {
    return {
        borderTopWidth: value,
        borderBottomWidth: value,
        borderRightWidth: value,
        borderLeftWidth: value
    };
};
exports["default"] = {
    longhandUtils: { margin: margin, padding: padding, borderRadius: borderRadius, borderWidth: borderWidth },
    utilities: {
        'bg-transparent': { backgroundColor: 'transparent' },
        'bg-bottom': { backgroundPosition: 'bottom' },
        'bg-center': { backgroundPosition: 'center' },
        'bg-left': { backgroundPosition: 'left' },
        'bg-left-bottom': { backgroundPosition: 'left bottom' },
        'bg-left-top': { backgroundPosition: 'left top' },
        'bg-right': { backgroundPosition: 'right' },
        'bg-right-bottom': { backgroundPosition: 'right bottom' },
        'bg-right-top': { backgroundPosition: 'right top' },
        'bg-top': { backgroundPosition: 'top' },
        'bg-auto': { backgroundSize: 'auto' },
        'bg-cover': { backgroundSize: 'cover' },
        'bg-contain': { backgroundSize: 'contain' },
        'rounded-0': borderRadius('0'),
        'rounded-1': borderRadius('1px'),
        'rounded-2': borderRadius('2px'),
        'rounded-4': borderRadius('4px'),
        'rounded-6': borderRadius('6px'),
        'rounded-8': borderRadius('8px'),
        'rounded-12': borderRadius('12px'),
        'rounded-16': borderRadius('16px'),
        'rounded-none': borderRadius('0'),
        'rounded-sm': borderRadius('0.125rem'),
        'rounded-md': borderRadius('0.375rem'),
        'rounded-lg': borderRadius('0.5rem'),
        rounded: borderRadius('1px'),
        'rounded-full': borderRadius('100%'),
        'rounded-t-0': { borderTopLeftRadius: '0', borderTopRightRadius: '0' },
        'rounded-r-0': { borderTopRightRadius: '0', borderBottomRightRadius: '0' },
        'rounded-b-0': { borderBottomRightRadius: '0', borderBottomLeftRadius: '0' },
        'rounded-l-0': { borderTopLeftRadius: '0', borderBottomLeftRadius: '0' },
        'rounded-t-1': { borderTopLeftRadius: '1px', borderTopRightRadius: '1px' },
        'rounded-r-1': { borderTopRightRadius: '1px', borderBottomRightRadius: '1px' },
        'rounded-b-1': { borderBottomRightRadius: '1px', borderBottomLeftRadius: '1px' },
        'rounded-l-1': { borderTopLeftRadius: '1px', borderBottomLeftRadius: '1px' },
        'rounded-t-2': { borderTopLeftRadius: '2px', borderTopRightRadius: '2px' },
        'rounded-r-2': { borderTopRightRadius: '2px', borderBottomRightRadius: '2px' },
        'rounded-b-2': { borderBottomRightRadius: '2px', borderBottomLeftRadius: '2px' },
        'rounded-l-2': { borderTopLeftRadius: '2px', borderBottomLeftRadius: '2px' },
        'rounded-t-4': { borderTopLeftRadius: '4px', borderTopRightRadius: '4px' },
        'rounded-r-4': { borderTopRightRadius: '4px', borderBottomRightRadius: '4px' },
        'rounded-b-4': { borderBottomRightRadius: '4px', borderBottomLeftRadius: '4px' },
        'rounded-l-4': { borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px' },
        'rounded-t-6': { borderTopLeftRadius: '6px', borderTopRightRadius: '6px' },
        'rounded-r-6': { borderTopRightRadius: '6px', borderBottomRightRadius: '6px' },
        'rounded-b-6': { borderBottomRightRadius: '6px', borderBottomLeftRadius: '6px' },
        'rounded-l-6': { borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' },
        'rounded-t-8': { borderTopLeftRadius: '8px', borderTopRightRadius: '8px' },
        'rounded-r-8': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
        'rounded-b-8': { borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px' },
        'rounded-l-8': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
        'rounded-t-12': { borderTopLeftRadius: '12px', borderTopRightRadius: '12px' },
        'rounded-r-12': { borderTopRightRadius: '12px', borderBottomRightRadius: '12px' },
        'rounded-b-12': { borderBottomRightRadius: '12px', borderBottomLeftRadius: '12px' },
        'rounded-l-12': { borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px' },
        'rounded-t-16': { borderTopLeftRadius: '16px', borderTopRightRadius: '16px' },
        'rounded-r-16': { borderTopRightRadius: '16px', borderBottomRightRadius: '16px' },
        'rounded-b-16': { borderBottomRightRadius: '16px', borderBottomLeftRadius: '16px' },
        'rounded-l-16': { borderTopLeftRadius: '16px', borderBottomLeftRadius: '16px' },
        'rounded-t-none': { borderTopLeftRadius: '0', borderTopRightRadius: '0' },
        'rounded-r-none': { borderTopRightRadius: '0', borderBottomRightRadius: '0' },
        'rounded-b-none': { borderBottomRightRadius: '0', borderBottomLeftRadius: '0' },
        'rounded-l-none': { borderTopLeftRadius: '0', borderBottomLeftRadius: '0' },
        'rounded-t-sm': { borderTopLeftRadius: '0.125rem', borderTopRightRadius: '0.125rem' },
        'rounded-r-sm': { borderTopRightRadius: '0.125rem', borderBottomRightRadius: '0.125rem' },
        'rounded-b-sm': { borderBottomRightRadius: '0.125rem', borderBottomLeftRadius: '0.125rem' },
        'rounded-l-sm': { borderTopLeftRadius: '0.125rem', borderBottomLeftRadius: '0.125rem' },
        'rounded-t-md': { borderTopLeftRadius: '0.375rem', borderTopRightRadius: '0.375rem' },
        'rounded-r-md': { borderTopRightRadius: '0.375rem', borderBottomRightRadius: '0.375rem' },
        'rounded-b-md': { borderBottomRightRadius: '0.375rem', borderBottomLeftRadius: '0.375rem' },
        'rounded-l-md': { borderTopLeftRadius: '0.375rem', borderBottomLeftRadius: '0.375rem' },
        'rounded-t-lg': { borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem' },
        'rounded-r-lg': { borderTopRightRadius: '0.5rem', borderBottomRightRadius: '0.5rem' },
        'rounded-b-lg': { borderBottomRightRadius: '0.5rem', borderBottomLeftRadius: '0.5rem' },
        'rounded-l-lg': { borderTopLeftRadius: '0.5rem', borderBottomLeftRadius: '0.5rem' },
        'rounded-t': { borderTopLeftRadius: '1px', borderTopRightRadius: '1px' },
        'rounded-r': { borderTopRightRadius: '1px', borderBottomRightRadius: '1px' },
        'rounded-b': { borderBottomRightRadius: '1px', borderBottomLeftRadius: '1px' },
        'rounded-l': { borderTopLeftRadius: '1px', borderBottomLeftRadius: '1px' },
        'rounded-t-full': { borderTopLeftRadius: '100%', borderTopRightRadius: '100%' },
        'rounded-r-full': { borderTopRightRadius: '100%', borderBottomRightRadius: '100%' },
        'rounded-b-full': { borderBottomRightRadius: '100%', borderBottomLeftRadius: '100%' },
        'rounded-l-full': { borderTopLeftRadius: '100%', borderBottomLeftRadius: '100%' },
        'rounded-tl-0': { borderTopLeftRadius: '0' },
        'rounded-tr-0': { borderTopRightRadius: '0' },
        'rounded-br-0': { borderBottomRightRadius: '0' },
        'rounded-bl-0': { borderBottomLeftRadius: '0' },
        'rounded-tl-1': { borderTopLeftRadius: '1px' },
        'rounded-tr-1': { borderTopRightRadius: '1px' },
        'rounded-br-1': { borderBottomRightRadius: '1px' },
        'rounded-bl-1': { borderBottomLeftRadius: '1px' },
        'rounded-tl-2': { borderTopLeftRadius: '2px' },
        'rounded-tr-2': { borderTopRightRadius: '2px' },
        'rounded-br-2': { borderBottomRightRadius: '2px' },
        'rounded-bl-2': { borderBottomLeftRadius: '2px' },
        'rounded-tl-4': { borderTopLeftRadius: '4px' },
        'rounded-tr-4': { borderTopRightRadius: '4px' },
        'rounded-br-4': { borderBottomRightRadius: '4px' },
        'rounded-bl-4': { borderBottomLeftRadius: '4px' },
        'rounded-tl-6': { borderTopLeftRadius: '6px' },
        'rounded-tr-6': { borderTopRightRadius: '6px' },
        'rounded-br-6': { borderBottomRightRadius: '6px' },
        'rounded-bl-6': { borderBottomLeftRadius: '6px' },
        'rounded-tl-8': { borderTopLeftRadius: '8px' },
        'rounded-tr-8': { borderTopRightRadius: '8px' },
        'rounded-br-8': { borderBottomRightRadius: '8px' },
        'rounded-bl-8': { borderBottomLeftRadius: '8px' },
        'rounded-tl-12': { borderTopLeftRadius: '12px' },
        'rounded-tr-12': { borderTopRightRadius: '12px' },
        'rounded-br-12': { borderBottomRightRadius: '12px' },
        'rounded-bl-12': { borderBottomLeftRadius: '12px' },
        'rounded-tl-16': { borderTopLeftRadius: '16px' },
        'rounded-tr-16': { borderTopRightRadius: '16px' },
        'rounded-br-16': { borderBottomRightRadius: '16px' },
        'rounded-bl-16': { borderBottomLeftRadius: '16px' },
        'rounded-tl-none': { borderTopLeftRadius: '0' },
        'rounded-tr-none': { borderTopRightRadius: '0' },
        'rounded-br-none': { borderBottomRightRadius: '0' },
        'rounded-bl-none': { borderBottomLeftRadius: '0' },
        'rounded-tl-sm': { borderTopLeftRadius: '0.125rem' },
        'rounded-tr-sm': { borderTopRightRadius: '0.125rem' },
        'rounded-br-sm': { borderBottomRightRadius: '0.125rem' },
        'rounded-bl-sm': { borderBottomLeftRadius: '0.125rem' },
        'rounded-tl-md': { borderTopLeftRadius: '0.375rem' },
        'rounded-tr-md': { borderTopRightRadius: '0.375rem' },
        'rounded-br-md': { borderBottomRightRadius: '0.375rem' },
        'rounded-bl-md': { borderBottomLeftRadius: '0.375rem' },
        'rounded-tl-lg': { borderTopLeftRadius: '0.5rem' },
        'rounded-tr-lg': { borderTopRightRadius: '0.5rem' },
        'rounded-br-lg': { borderBottomRightRadius: '0.5rem' },
        'rounded-bl-lg': { borderBottomLeftRadius: '0.5rem' },
        'rounded-tl': { borderTopLeftRadius: '1px' },
        'rounded-tr': { borderTopRightRadius: '1px' },
        'rounded-br': { borderBottomRightRadius: '1px' },
        'rounded-bl': { borderBottomLeftRadius: '1px' },
        'rounded-tl-full': { borderTopLeftRadius: '100%' },
        'rounded-tr-full': { borderTopRightRadius: '100%' },
        'rounded-br-full': { borderBottomRightRadius: '100%' },
        'rounded-bl-full': { borderBottomLeftRadius: '100%' },
        'border-0': borderWidth('0'),
        'border-1': borderWidth('1px'),
        'border-2': borderWidth('2px'),
        'border-4': borderWidth('4px'),
        'border-6': borderWidth('6px'),
        'border-8': borderWidth('8px'),
        'border-12': borderWidth('12px'),
        'border-16': borderWidth('16px'),
        border: borderWidth('1px'),
        'border-t-0': { borderTopWidth: '0' },
        'border-r-0': { borderRightWidth: '0' },
        'border-b-0': { borderBottomWidth: '0' },
        'border-l-0': { borderLeftWidth: '0' },
        'border-t-1': { borderTopWidth: '1px' },
        'border-r-1': { borderRightWidth: '1px' },
        'border-b-1': { borderBottomWidth: '1px' },
        'border-l-1': { borderLeftWidth: '1px' },
        'border-t-2': { borderTopWidth: '2px' },
        'border-r-2': { borderRightWidth: '2px' },
        'border-b-2': { borderBottomWidth: '2px' },
        'border-l-2': { borderLeftWidth: '2px' },
        'border-t-4': { borderTopWidth: '4px' },
        'border-r-4': { borderRightWidth: '4px' },
        'border-b-4': { borderBottomWidth: '4px' },
        'border-l-4': { borderLeftWidth: '4px' },
        'border-t-6': { borderTopWidth: '6px' },
        'border-r-6': { borderRightWidth: '6px' },
        'border-b-6': { borderBottomWidth: '6px' },
        'border-l-6': { borderLeftWidth: '6px' },
        'border-t-8': { borderTopWidth: '8px' },
        'border-r-8': { borderRightWidth: '8px' },
        'border-b-8': { borderBottomWidth: '8px' },
        'border-l-8': { borderLeftWidth: '8px' },
        'border-t-12': { borderTopWidth: '12px' },
        'border-r-12': { borderRightWidth: '12px' },
        'border-b-12': { borderBottomWidth: '12px' },
        'border-l-12': { borderLeftWidth: '12px' },
        'border-t-16': { borderTopWidth: '16px' },
        'border-r-16': { borderRightWidth: '16px' },
        'border-b-16': { borderBottomWidth: '16px' },
        'border-l-16': { borderLeftWidth: '16px' },
        'border-t': { borderTopWidth: '1px' },
        'border-r': { borderRightWidth: '1px' },
        'border-b': { borderBottomWidth: '1px' },
        'border-l': { borderLeftWidth: '1px' },
        'cursor-auto': { cursor: 'auto' },
        'cursor-default': { cursor: 'default' },
        'cursor-pointer': { cursor: 'pointer' },
        'cursor-wait': { cursor: 'wait' },
        'cursor-text': { cursor: 'text' },
        'cursor-move': { cursor: 'move' },
        'cursor-not-allowed': { cursor: 'not-allowed' },
        'fill-current': { fill: 'currentColor' },
        'flex-1': { flexGrow: '1', flexShrink: '1', flexBasis: '0%' },
        'flex-auto': { flexGrow: '1', flexShrink: '1', flexBasis: 'auto' },
        'flex-initial': { flexGrow: '0', flexShrink: '1', flexBasis: 'auto' },
        'flex-none': { flexGrow: '0', flexShrink: '0', flexBasis: 'auto' },
        'flex-grow-0': { flexGrow: '0' },
        'flex-grow': { flexGrow: '1' },
        'flex-shrink-0': { flexShrink: '0' },
        'flex-shrink': { flexShrink: '1' },
        'font-sans': {
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
        },
        'font-serif': { fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' },
        'font-mono': { fontFamily: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace' },
        'font-300': { fontWeight: '300' },
        'font-400': { fontWeight: '400' },
        'font-500': { fontWeight: '500' },
        'font-600': { fontWeight: '600' },
        'font-700': { fontWeight: '700' },
        'font-hairline': { fontWeight: '100' },
        'font-thin': { fontWeight: '200' },
        'font-light': { fontWeight: '300' },
        'font-normal': { fontWeight: '400' },
        'font-regular': { fontWeight: '400' },
        'font-medium': { fontWeight: '500' },
        'font-semibold': { fontWeight: '600' },
        'font-bold': { fontWeight: '700' },
        'font-extrabold': { fontWeight: '800' },
        'font-black': { fontWeight: '900' },
        'h-0': { height: '0' },
        'h-1': { height: '0.4rem' },
        'h-2': { height: '0.8rem' },
        'h-3': { height: '1.2rem' },
        'h-4': { height: '1.6rem' },
        'h-5': { height: '2rem' },
        'h-6': { height: '2.4rem' },
        'h-7': { height: '2.8rem' },
        'h-8': { height: '3.2rem' },
        'h-9': { height: '3.6rem' },
        'h-10': { height: '4rem' },
        'h-11': { height: '4.4rem' },
        'h-12': { height: '4.8rem' },
        'h-16': { height: '6.4rem' },
        'h-20': { height: '8rem' },
        'h-24': { height: '9.6rem' },
        'h-32': { height: '12.8rem' },
        'h-40': { height: '16rem' },
        'h-48': { height: '19.2rem' },
        'h-56': { height: '22.4rem' },
        'h-64': { height: '25.6rem' },
        'h-auto': { height: 'auto' },
        'h-px': { height: '1px' },
        'h-1/2': { height: '50%' },
        'h-full': { height: '100%' },
        'h-screen': { height: '100vh' },
        'inset-0': { top: '0', right: '0', bottom: '0', left: '0' },
        'inset-auto': { top: 'auto', right: 'auto', bottom: 'auto', left: 'auto' },
        'inset-y-0': { top: '0', bottom: '0' },
        'inset-x-0': { right: '0', left: '0' },
        'inset-y-auto': { top: 'auto', bottom: 'auto' },
        'inset-x-auto': { right: 'auto', left: 'auto' },
        'top-0': { top: '0' },
        'right-0': { right: '0' },
        'bottom-0': { bottom: '0' },
        'left-0': { left: '0' },
        'top-auto': { top: 'auto' },
        'right-auto': { right: 'auto' },
        'bottom-auto': { bottom: 'auto' },
        'left-auto': { left: 'auto' },
        'tracking-tighter': { letterSpacing: '-0.05em' },
        'tracking-tight': { letterSpacing: '-0.025em' },
        'tracking-normal': { letterSpacing: '0' },
        'tracking-wide': { letterSpacing: '0.025em' },
        'tracking-wider': { letterSpacing: '0.05em' },
        'tracking-widest': { letterSpacing: '0.1em' },
        'leading-3': { lineHeight: '.75rem' },
        'leading-4': { lineHeight: '1rem' },
        'leading-5': { lineHeight: '1.25rem' },
        'leading-6': { lineHeight: '1.5rem' },
        'leading-7': { lineHeight: '1.75rem' },
        'leading-8': { lineHeight: '2rem' },
        'leading-9': { lineHeight: '2.25rem' },
        'leading-10': { lineHeight: '2.5rem' },
        'leading-none': { lineHeight: '1' },
        'leading-tight': { lineHeight: '1.25' },
        'leading-snug': { lineHeight: '1.375' },
        'leading-normal': { lineHeight: '1.5' },
        'leading-relaxed': { lineHeight: '1.625' },
        'leading-loose': { lineHeight: '2' },
        'list-none': { listStyleType: 'none' },
        'list-disc': { listStyleType: 'disc' },
        'list-decimal': { listStyleType: 'decimal' },
        'm-0': margin('0'),
        'm-1': margin('0.4rem'),
        'm-2': margin('0.8rem'),
        'm-3': margin('1.2rem'),
        'm-4': margin('1.6rem'),
        'm-5': margin('2rem'),
        'm-6': margin('2.4rem'),
        'm-7': margin('2.8rem'),
        'm-8': margin('3.2rem'),
        'm-9': margin('3.6rem'),
        'm-10': margin('4rem'),
        'm-11': margin('4.4rem'),
        'm-12': margin('4.8rem'),
        'm-16': margin('6.4rem'),
        'm-20': margin('8rem'),
        'm-24': margin('9.6rem'),
        'm-32': margin('12.8rem'),
        'm-40': margin('16rem'),
        'm-48': margin('19.2rem'),
        'm-56': margin('22.4rem'),
        'm-64': margin('25.6rem'),
        'm-auto': margin('auto'),
        'm-1.5': margin('0.6rem'),
        'm-0.5': margin('0.2rem'),
        '-m-1.5': margin('-0.6rem'),
        '-m-0.5': margin('-0.2rem'),
        'm-px': margin('1px'),
        '-m-1': margin('-0.4rem'),
        '-m-2': margin('-0.8rem'),
        '-m-3': margin('-1.2rem'),
        '-m-4': margin('-1.6rem'),
        '-m-5': margin('-2rem'),
        '-m-6': margin('-2.4rem'),
        '-m-7': margin('-2.8rem'),
        '-m-8': margin('-3.2rem'),
        '-m-9': margin('-3.6rem'),
        '-m-10': margin('-4rem'),
        '-m-11': margin('-4.4rem'),
        '-m-12': margin('-4.8rem'),
        '-m-16': margin('-6.4rem'),
        '-m-20': margin('-8rem'),
        '-m-24': margin('-9.6rem'),
        '-m-32': margin('-12.8rem'),
        '-m-40': margin('-16rem'),
        '-m-48': margin('-19.2rem'),
        '-m-56': margin('-22.4rem'),
        '-m-64': margin('-25.6rem'),
        '-m-px': margin('-1px'),
        'my-0': { marginTop: '0', marginBottom: '0' },
        'mx-0': { marginLeft: '0', marginRight: '0' },
        'my-1': { marginTop: '0.4rem', marginBottom: '0.4rem' },
        'mx-1': { marginLeft: '0.4rem', marginRight: '0.4rem' },
        'my-2': { marginTop: '0.8rem', marginBottom: '0.8rem' },
        'mx-2': { marginLeft: '0.8rem', marginRight: '0.8rem' },
        'my-3': { marginTop: '1.2rem', marginBottom: '1.2rem' },
        'mx-3': { marginLeft: '1.2rem', marginRight: '1.2rem' },
        'my-4': { marginTop: '1.6rem', marginBottom: '1.6rem' },
        'mx-4': { marginLeft: '1.6rem', marginRight: '1.6rem' },
        'my-5': { marginTop: '2rem', marginBottom: '2rem' },
        'mx-5': { marginLeft: '2rem', marginRight: '2rem' },
        'my-6': { marginTop: '2.4rem', marginBottom: '2.4rem' },
        'mx-6': { marginLeft: '2.4rem', marginRight: '2.4rem' },
        'my-7': { marginTop: '2.8rem', marginBottom: '2.8rem' },
        'mx-7': { marginLeft: '2.8rem', marginRight: '2.8rem' },
        'my-8': { marginTop: '3.2rem', marginBottom: '3.2rem' },
        'mx-8': { marginLeft: '3.2rem', marginRight: '3.2rem' },
        'my-9': { marginTop: '3.6rem', marginBottom: '3.6rem' },
        'mx-9': { marginLeft: '3.6rem', marginRight: '3.6rem' },
        'my-10': { marginTop: '4rem', marginBottom: '4rem' },
        'mx-10': { marginLeft: '4rem', marginRight: '4rem' },
        'my-11': { marginTop: '4.4rem', marginBottom: '4.4rem' },
        'mx-11': { marginLeft: '4.4rem', marginRight: '4.4rem' },
        'my-12': { marginTop: '4.8rem', marginBottom: '4.8rem' },
        'mx-12': { marginLeft: '4.8rem', marginRight: '4.8rem' },
        'my-16': { marginTop: '6.4rem', marginBottom: '6.4rem' },
        'mx-16': { marginLeft: '6.4rem', marginRight: '6.4rem' },
        'my-20': { marginTop: '8rem', marginBottom: '8rem' },
        'mx-20': { marginLeft: '8rem', marginRight: '8rem' },
        'my-24': { marginTop: '9.6rem', marginBottom: '9.6rem' },
        'mx-24': { marginLeft: '9.6rem', marginRight: '9.6rem' },
        'my-32': { marginTop: '12.8rem', marginBottom: '12.8rem' },
        'mx-32': { marginLeft: '12.8rem', marginRight: '12.8rem' },
        'my-40': { marginTop: '16rem', marginBottom: '16rem' },
        'mx-40': { marginLeft: '16rem', marginRight: '16rem' },
        'my-48': { marginTop: '19.2rem', marginBottom: '19.2rem' },
        'mx-48': { marginLeft: '19.2rem', marginRight: '19.2rem' },
        'my-56': { marginTop: '22.4rem', marginBottom: '22.4rem' },
        'mx-56': { marginLeft: '22.4rem', marginRight: '22.4rem' },
        'my-64': { marginTop: '25.6rem', marginBottom: '25.6rem' },
        'mx-64': { marginLeft: '25.6rem', marginRight: '25.6rem' },
        'my-auto': { marginTop: 'auto', marginBottom: 'auto' },
        'mx-auto': { marginLeft: 'auto', marginRight: 'auto' },
        'my-1.5': { marginTop: '0.6rem', marginBottom: '0.6rem' },
        'mx-1.5': { marginLeft: '0.6rem', marginRight: '0.6rem' },
        'my-0.5': { marginTop: '0.2rem', marginBottom: '0.2rem' },
        'mx-0.5': { marginLeft: '0.2rem', marginRight: '0.2rem' },
        '-my-1.5': { marginTop: '-0.6rem', marginBottom: '-0.6rem' },
        '-mx-1.5': { marginLeft: '-0.6rem', marginRight: '-0.6rem' },
        '-my-0.5': { marginTop: '-0.2rem', marginBottom: '-0.2rem' },
        '-mx-0.5': { marginLeft: '-0.2rem', marginRight: '-0.2rem' },
        'my-px': { marginTop: '1px', marginBottom: '1px' },
        'mx-px': { marginLeft: '1px', marginRight: '1px' },
        '-my-1': { marginTop: '-0.4rem', marginBottom: '-0.4rem' },
        '-mx-1': { marginLeft: '-0.4rem', marginRight: '-0.4rem' },
        '-my-2': { marginTop: '-0.8rem', marginBottom: '-0.8rem' },
        '-mx-2': { marginLeft: '-0.8rem', marginRight: '-0.8rem' },
        '-my-3': { marginTop: '-1.2rem', marginBottom: '-1.2rem' },
        '-mx-3': { marginLeft: '-1.2rem', marginRight: '-1.2rem' },
        '-my-4': { marginTop: '-1.6rem', marginBottom: '-1.6rem' },
        '-mx-4': { marginLeft: '-1.6rem', marginRight: '-1.6rem' },
        '-my-5': { marginTop: '-2rem', marginBottom: '-2rem' },
        '-mx-5': { marginLeft: '-2rem', marginRight: '-2rem' },
        '-my-6': { marginTop: '-2.4rem', marginBottom: '-2.4rem' },
        '-mx-6': { marginLeft: '-2.4rem', marginRight: '-2.4rem' },
        '-my-7': { marginTop: '-2.8rem', marginBottom: '-2.8rem' },
        '-mx-7': { marginLeft: '-2.8rem', marginRight: '-2.8rem' },
        '-my-8': { marginTop: '-3.2rem', marginBottom: '-3.2rem' },
        '-mx-8': { marginLeft: '-3.2rem', marginRight: '-3.2rem' },
        '-my-9': { marginTop: '-3.6rem', marginBottom: '-3.6rem' },
        '-mx-9': { marginLeft: '-3.6rem', marginRight: '-3.6rem' },
        '-my-10': { marginTop: '-4rem', marginBottom: '-4rem' },
        '-mx-10': { marginLeft: '-4rem', marginRight: '-4rem' },
        '-my-11': { marginTop: '-4.4rem', marginBottom: '-4.4rem' },
        '-mx-11': { marginLeft: '-4.4rem', marginRight: '-4.4rem' },
        '-my-12': { marginTop: '-4.8rem', marginBottom: '-4.8rem' },
        '-mx-12': { marginLeft: '-4.8rem', marginRight: '-4.8rem' },
        '-my-16': { marginTop: '-6.4rem', marginBottom: '-6.4rem' },
        '-mx-16': { marginLeft: '-6.4rem', marginRight: '-6.4rem' },
        '-my-20': { marginTop: '-8rem', marginBottom: '-8rem' },
        '-mx-20': { marginLeft: '-8rem', marginRight: '-8rem' },
        '-my-24': { marginTop: '-9.6rem', marginBottom: '-9.6rem' },
        '-mx-24': { marginLeft: '-9.6rem', marginRight: '-9.6rem' },
        '-my-32': { marginTop: '-12.8rem', marginBottom: '-12.8rem' },
        '-mx-32': { marginLeft: '-12.8rem', marginRight: '-12.8rem' },
        '-my-40': { marginTop: '-16rem', marginBottom: '-16rem' },
        '-mx-40': { marginLeft: '-16rem', marginRight: '-16rem' },
        '-my-48': { marginTop: '-19.2rem', marginBottom: '-19.2rem' },
        '-mx-48': { marginLeft: '-19.2rem', marginRight: '-19.2rem' },
        '-my-56': { marginTop: '-22.4rem', marginBottom: '-22.4rem' },
        '-mx-56': { marginLeft: '-22.4rem', marginRight: '-22.4rem' },
        '-my-64': { marginTop: '-25.6rem', marginBottom: '-25.6rem' },
        '-mx-64': { marginLeft: '-25.6rem', marginRight: '-25.6rem' },
        '-my-px': { marginTop: '-1px', marginBottom: '-1px' },
        '-mx-px': { marginLeft: '-1px', marginRight: '-1px' },
        'mt-0': { marginTop: '0' },
        'mr-0': { marginRight: '0' },
        'mb-0': { marginBottom: '0' },
        'ml-0': { marginLeft: '0' },
        'mt-1': { marginTop: '0.4rem' },
        'mr-1': { marginRight: '0.4rem' },
        'mb-1': { marginBottom: '0.4rem' },
        'ml-1': { marginLeft: '0.4rem' },
        'mt-2': { marginTop: '0.8rem' },
        'mr-2': { marginRight: '0.8rem' },
        'mb-2': { marginBottom: '0.8rem' },
        'ml-2': { marginLeft: '0.8rem' },
        'mt-3': { marginTop: '1.2rem' },
        'mr-3': { marginRight: '1.2rem' },
        'mb-3': { marginBottom: '1.2rem' },
        'ml-3': { marginLeft: '1.2rem' },
        'mt-4': { marginTop: '1.6rem' },
        'mr-4': { marginRight: '1.6rem' },
        'mb-4': { marginBottom: '1.6rem' },
        'ml-4': { marginLeft: '1.6rem' },
        'mt-5': { marginTop: '2rem' },
        'mr-5': { marginRight: '2rem' },
        'mb-5': { marginBottom: '2rem' },
        'ml-5': { marginLeft: '2rem' },
        'mt-6': { marginTop: '2.4rem' },
        'mr-6': { marginRight: '2.4rem' },
        'mb-6': { marginBottom: '2.4rem' },
        'ml-6': { marginLeft: '2.4rem' },
        'mt-7': { marginTop: '2.8rem' },
        'mr-7': { marginRight: '2.8rem' },
        'mb-7': { marginBottom: '2.8rem' },
        'ml-7': { marginLeft: '2.8rem' },
        'mt-8': { marginTop: '3.2rem' },
        'mr-8': { marginRight: '3.2rem' },
        'mb-8': { marginBottom: '3.2rem' },
        'ml-8': { marginLeft: '3.2rem' },
        'mt-9': { marginTop: '3.6rem' },
        'mr-9': { marginRight: '3.6rem' },
        'mb-9': { marginBottom: '3.6rem' },
        'ml-9': { marginLeft: '3.6rem' },
        'mt-10': { marginTop: '4rem' },
        'mr-10': { marginRight: '4rem' },
        'mb-10': { marginBottom: '4rem' },
        'ml-10': { marginLeft: '4rem' },
        'mt-11': { marginTop: '4.4rem' },
        'mr-11': { marginRight: '4.4rem' },
        'mb-11': { marginBottom: '4.4rem' },
        'ml-11': { marginLeft: '4.4rem' },
        'mt-12': { marginTop: '4.8rem' },
        'mr-12': { marginRight: '4.8rem' },
        'mb-12': { marginBottom: '4.8rem' },
        'ml-12': { marginLeft: '4.8rem' },
        'mt-16': { marginTop: '6.4rem' },
        'mr-16': { marginRight: '6.4rem' },
        'mb-16': { marginBottom: '6.4rem' },
        'ml-16': { marginLeft: '6.4rem' },
        'mt-20': { marginTop: '8rem' },
        'mr-20': { marginRight: '8rem' },
        'mb-20': { marginBottom: '8rem' },
        'ml-20': { marginLeft: '8rem' },
        'mt-24': { marginTop: '9.6rem' },
        'mr-24': { marginRight: '9.6rem' },
        'mb-24': { marginBottom: '9.6rem' },
        'ml-24': { marginLeft: '9.6rem' },
        'mt-32': { marginTop: '12.8rem' },
        'mr-32': { marginRight: '12.8rem' },
        'mb-32': { marginBottom: '12.8rem' },
        'ml-32': { marginLeft: '12.8rem' },
        'mt-40': { marginTop: '16rem' },
        'mr-40': { marginRight: '16rem' },
        'mb-40': { marginBottom: '16rem' },
        'ml-40': { marginLeft: '16rem' },
        'mt-48': { marginTop: '19.2rem' },
        'mr-48': { marginRight: '19.2rem' },
        'mb-48': { marginBottom: '19.2rem' },
        'ml-48': { marginLeft: '19.2rem' },
        'mt-56': { marginTop: '22.4rem' },
        'mr-56': { marginRight: '22.4rem' },
        'mb-56': { marginBottom: '22.4rem' },
        'ml-56': { marginLeft: '22.4rem' },
        'mt-64': { marginTop: '25.6rem' },
        'mr-64': { marginRight: '25.6rem' },
        'mb-64': { marginBottom: '25.6rem' },
        'ml-64': { marginLeft: '25.6rem' },
        'mt-auto': { marginTop: 'auto' },
        'mr-auto': { marginRight: 'auto' },
        'mb-auto': { marginBottom: 'auto' },
        'ml-auto': { marginLeft: 'auto' },
        'mt-1.5': { marginTop: '0.6rem' },
        'mr-1.5': { marginRight: '0.6rem' },
        'mb-1.5': { marginBottom: '0.6rem' },
        'ml-1.5': { marginLeft: '0.6rem' },
        'mt-0.5': { marginTop: '0.2rem' },
        'mr-0.5': { marginRight: '0.2rem' },
        'mb-0.5': { marginBottom: '0.2rem' },
        'ml-0.5': { marginLeft: '0.2rem' },
        '-mt-1.5': { marginTop: '-0.6rem' },
        '-mr-1.5': { marginRight: '-0.6rem' },
        '-mb-1.5': { marginBottom: '-0.6rem' },
        '-ml-1.5': { marginLeft: '-0.6rem' },
        '-mt-0.5': { marginTop: '-0.2rem' },
        '-mr-0.5': { marginRight: '-0.2rem' },
        '-mb-0.5': { marginBottom: '-0.2rem' },
        '-ml-0.5': { marginLeft: '-0.2rem' },
        'mt-px': { marginTop: '1px' },
        'mr-px': { marginRight: '1px' },
        'mb-px': { marginBottom: '1px' },
        'ml-px': { marginLeft: '1px' },
        '-mt-1': { marginTop: '-0.4rem' },
        '-mr-1': { marginRight: '-0.4rem' },
        '-mb-1': { marginBottom: '-0.4rem' },
        '-ml-1': { marginLeft: '-0.4rem' },
        '-mt-2': { marginTop: '-0.8rem' },
        '-mr-2': { marginRight: '-0.8rem' },
        '-mb-2': { marginBottom: '-0.8rem' },
        '-ml-2': { marginLeft: '-0.8rem' },
        '-mt-3': { marginTop: '-1.2rem' },
        '-mr-3': { marginRight: '-1.2rem' },
        '-mb-3': { marginBottom: '-1.2rem' },
        '-ml-3': { marginLeft: '-1.2rem' },
        '-mt-4': { marginTop: '-1.6rem' },
        '-mr-4': { marginRight: '-1.6rem' },
        '-mb-4': { marginBottom: '-1.6rem' },
        '-ml-4': { marginLeft: '-1.6rem' },
        '-mt-5': { marginTop: '-2rem' },
        '-mr-5': { marginRight: '-2rem' },
        '-mb-5': { marginBottom: '-2rem' },
        '-ml-5': { marginLeft: '-2rem' },
        '-mt-6': { marginTop: '-2.4rem' },
        '-mr-6': { marginRight: '-2.4rem' },
        '-mb-6': { marginBottom: '-2.4rem' },
        '-ml-6': { marginLeft: '-2.4rem' },
        '-mt-7': { marginTop: '-2.8rem' },
        '-mr-7': { marginRight: '-2.8rem' },
        '-mb-7': { marginBottom: '-2.8rem' },
        '-ml-7': { marginLeft: '-2.8rem' },
        '-mt-8': { marginTop: '-3.2rem' },
        '-mr-8': { marginRight: '-3.2rem' },
        '-mb-8': { marginBottom: '-3.2rem' },
        '-ml-8': { marginLeft: '-3.2rem' },
        '-mt-9': { marginTop: '-3.6rem' },
        '-mr-9': { marginRight: '-3.6rem' },
        '-mb-9': { marginBottom: '-3.6rem' },
        '-ml-9': { marginLeft: '-3.6rem' },
        '-mt-10': { marginTop: '-4rem' },
        '-mr-10': { marginRight: '-4rem' },
        '-mb-10': { marginBottom: '-4rem' },
        '-ml-10': { marginLeft: '-4rem' },
        '-mt-11': { marginTop: '-4.4rem' },
        '-mr-11': { marginRight: '-4.4rem' },
        '-mb-11': { marginBottom: '-4.4rem' },
        '-ml-11': { marginLeft: '-4.4rem' },
        '-mt-12': { marginTop: '-4.8rem' },
        '-mr-12': { marginRight: '-4.8rem' },
        '-mb-12': { marginBottom: '-4.8rem' },
        '-ml-12': { marginLeft: '-4.8rem' },
        '-mt-16': { marginTop: '-6.4rem' },
        '-mr-16': { marginRight: '-6.4rem' },
        '-mb-16': { marginBottom: '-6.4rem' },
        '-ml-16': { marginLeft: '-6.4rem' },
        '-mt-20': { marginTop: '-8rem' },
        '-mr-20': { marginRight: '-8rem' },
        '-mb-20': { marginBottom: '-8rem' },
        '-ml-20': { marginLeft: '-8rem' },
        '-mt-24': { marginTop: '-9.6rem' },
        '-mr-24': { marginRight: '-9.6rem' },
        '-mb-24': { marginBottom: '-9.6rem' },
        '-ml-24': { marginLeft: '-9.6rem' },
        '-mt-32': { marginTop: '-12.8rem' },
        '-mr-32': { marginRight: '-12.8rem' },
        '-mb-32': { marginBottom: '-12.8rem' },
        '-ml-32': { marginLeft: '-12.8rem' },
        '-mt-40': { marginTop: '-16rem' },
        '-mr-40': { marginRight: '-16rem' },
        '-mb-40': { marginBottom: '-16rem' },
        '-ml-40': { marginLeft: '-16rem' },
        '-mt-48': { marginTop: '-19.2rem' },
        '-mr-48': { marginRight: '-19.2rem' },
        '-mb-48': { marginBottom: '-19.2rem' },
        '-ml-48': { marginLeft: '-19.2rem' },
        '-mt-56': { marginTop: '-22.4rem' },
        '-mr-56': { marginRight: '-22.4rem' },
        '-mb-56': { marginBottom: '-22.4rem' },
        '-ml-56': { marginLeft: '-22.4rem' },
        '-mt-64': { marginTop: '-25.6rem' },
        '-mr-64': { marginRight: '-25.6rem' },
        '-mb-64': { marginBottom: '-25.6rem' },
        '-ml-64': { marginLeft: '-25.6rem' },
        '-mt-px': { marginTop: '-1px' },
        '-mr-px': { marginRight: '-1px' },
        '-mb-px': { marginBottom: '-1px' },
        '-ml-px': { marginLeft: '-1px' },
        'max-h-full': { maxHeight: '100%' },
        'max-h-screen': { maxHeight: '100vh' },
        'max-w-none': { maxWidth: 'none' },
        'max-w-xs': { maxWidth: '20rem' },
        'max-w-sm': { maxWidth: '24rem' },
        'max-w-md': { maxWidth: '28rem' },
        'max-w-lg': { maxWidth: '32rem' },
        'max-w-xl': { maxWidth: '36rem' },
        'max-w-2xl': { maxWidth: '42rem' },
        'max-w-3xl': { maxWidth: '48rem' },
        'max-w-4xl': { maxWidth: '56rem' },
        'max-w-5xl': { maxWidth: '64rem' },
        'max-w-6xl': { maxWidth: '72rem' },
        'max-w-full': { maxWidth: '100%' },
        'max-w-screen-sm': { maxWidth: '640px' },
        'max-w-screen-md': { maxWidth: '768px' },
        'max-w-screen-lg': { maxWidth: '1024px' },
        'max-w-screen-xl': { maxWidth: '1280px' },
        'min-h-0': { minHeight: '0' },
        'min-h-full': { minHeight: '100%' },
        'min-h-screen': { minHeight: '100vh' },
        'min-w-0': { minWidth: '0' },
        'min-w-full': { minWidth: '100%' },
        'object-bottom': { objectPosition: 'bottom' },
        'object-center': { objectPosition: 'center' },
        'object-left': { objectPosition: 'left' },
        'object-left-bottom': { objectPosition: 'left bottom' },
        'object-left-top': { objectPosition: 'left top' },
        'object-right': { objectPosition: 'right' },
        'object-right-bottom': { objectPosition: 'right bottom' },
        'object-right-top': { objectPosition: 'right top' },
        'object-top': { objectPosition: 'top' },
        'opacity-0': { opacity: '0' },
        'opacity-5': { opacity: '0.05' },
        'opacity-10': { opacity: '0.1' },
        'opacity-15': { opacity: '0.15' },
        'opacity-20': { opacity: '0.2' },
        'opacity-25': { opacity: '0.25' },
        'opacity-30': { opacity: '0.3' },
        'opacity-40': { opacity: '0.4' },
        'opacity-50': { opacity: '0.5' },
        'opacity-60': { opacity: '0.6' },
        'opacity-70': { opacity: '0.7' },
        'opacity-75': { opacity: '0.75' },
        'opacity-80': { opacity: '0.8' },
        'opacity-90': { opacity: '0.9' },
        'opacity-100': { opacity: '1' },
        'order-1': { order: '1' },
        'order-2': { order: '2' },
        'order-3': { order: '3' },
        'order-4': { order: '4' },
        'order-5': { order: '5' },
        'order-6': { order: '6' },
        'order-7': { order: '7' },
        'order-8': { order: '8' },
        'order-9': { order: '9' },
        'order-10': { order: '10' },
        'order-11': { order: '11' },
        'order-12': { order: '12' },
        'order-13': { order: '13' },
        'order-14': { order: '14' },
        'order-15': { order: '15' },
        'order-16': { order: '16' },
        'order-17': { order: '17' },
        'order-18': { order: '18' },
        'order-19': { order: '19' },
        'order-20': { order: '20' },
        'order-21': { order: '21' },
        'order-22': { order: '22' },
        'order-23': { order: '23' },
        'order-24': { order: '24' },
        'order-first': { order: '-9999' },
        'order-last': { order: '9999' },
        'order-none': { order: '0' },
        'p-0': padding('0'),
        'p-1': padding('0.4rem'),
        'p-2': padding('0.8rem'),
        'p-3': padding('1.2rem'),
        'p-4': padding('1.6rem'),
        'p-5': padding('2rem'),
        'p-6': padding('2.4rem'),
        'p-7': padding('2.8rem'),
        'p-8': padding('3.2rem'),
        'p-9': padding('3.6rem'),
        'p-10': padding('4rem'),
        'p-11': padding('4.4rem'),
        'p-12': padding('4.8rem'),
        'p-16': padding('6.4rem'),
        'p-20': padding('8rem'),
        'p-24': padding('9.6rem'),
        'p-32': padding('12.8rem'),
        'p-40': padding('16rem'),
        'p-48': padding('19.2rem'),
        'p-56': padding('22.4rem'),
        'p-64': padding('25.6rem'),
        'p-1.5': padding('0.6rem'),
        'p-0.5': padding('0.2rem'),
        'p-px': padding('1px'),
        'py-0': { paddingTop: '0', paddingBottom: '0' },
        'px-0': { paddingLeft: '0', paddingRight: '0' },
        'py-1': { paddingTop: '0.4rem', paddingBottom: '0.4rem' },
        'px-1': { paddingLeft: '0.4rem', paddingRight: '0.4rem' },
        'py-2': { paddingTop: '0.8rem', paddingBottom: '0.8rem' },
        'px-2': { paddingLeft: '0.8rem', paddingRight: '0.8rem' },
        'py-3': { paddingTop: '1.2rem', paddingBottom: '1.2rem' },
        'px-3': { paddingLeft: '1.2rem', paddingRight: '1.2rem' },
        'py-4': { paddingTop: '1.6rem', paddingBottom: '1.6rem' },
        'px-4': { paddingLeft: '1.6rem', paddingRight: '1.6rem' },
        'py-5': { paddingTop: '2rem', paddingBottom: '2rem' },
        'px-5': { paddingLeft: '2rem', paddingRight: '2rem' },
        'py-6': { paddingTop: '2.4rem', paddingBottom: '2.4rem' },
        'px-6': { paddingLeft: '2.4rem', paddingRight: '2.4rem' },
        'py-7': { paddingTop: '2.8rem', paddingBottom: '2.8rem' },
        'px-7': { paddingLeft: '2.8rem', paddingRight: '2.8rem' },
        'py-8': { paddingTop: '3.2rem', paddingBottom: '3.2rem' },
        'px-8': { paddingLeft: '3.2rem', paddingRight: '3.2rem' },
        'py-9': { paddingTop: '3.6rem', paddingBottom: '3.6rem' },
        'px-9': { paddingLeft: '3.6rem', paddingRight: '3.6rem' },
        'py-10': { paddingTop: '4rem', paddingBottom: '4rem' },
        'px-10': { paddingLeft: '4rem', paddingRight: '4rem' },
        'py-11': { paddingTop: '4.4rem', paddingBottom: '4.4rem' },
        'px-11': { paddingLeft: '4.4rem', paddingRight: '4.4rem' },
        'py-12': { paddingTop: '4.8rem', paddingBottom: '4.8rem' },
        'px-12': { paddingLeft: '4.8rem', paddingRight: '4.8rem' },
        'py-16': { paddingTop: '6.4rem', paddingBottom: '6.4rem' },
        'px-16': { paddingLeft: '6.4rem', paddingRight: '6.4rem' },
        'py-20': { paddingTop: '8rem', paddingBottom: '8rem' },
        'px-20': { paddingLeft: '8rem', paddingRight: '8rem' },
        'py-24': { paddingTop: '9.6rem', paddingBottom: '9.6rem' },
        'px-24': { paddingLeft: '9.6rem', paddingRight: '9.6rem' },
        'py-32': { paddingTop: '12.8rem', paddingBottom: '12.8rem' },
        'px-32': { paddingLeft: '12.8rem', paddingRight: '12.8rem' },
        'py-40': { paddingTop: '16rem', paddingBottom: '16rem' },
        'px-40': { paddingLeft: '16rem', paddingRight: '16rem' },
        'py-48': { paddingTop: '19.2rem', paddingBottom: '19.2rem' },
        'px-48': { paddingLeft: '19.2rem', paddingRight: '19.2rem' },
        'py-56': { paddingTop: '22.4rem', paddingBottom: '22.4rem' },
        'px-56': { paddingLeft: '22.4rem', paddingRight: '22.4rem' },
        'py-64': { paddingTop: '25.6rem', paddingBottom: '25.6rem' },
        'px-64': { paddingLeft: '25.6rem', paddingRight: '25.6rem' },
        'py-1.5': { paddingTop: '0.6rem', paddingBottom: '0.6rem' },
        'px-1.5': { paddingLeft: '0.6rem', paddingRight: '0.6rem' },
        'py-0.5': { paddingTop: '0.2rem', paddingBottom: '0.2rem' },
        'px-0.5': { paddingLeft: '0.2rem', paddingRight: '0.2rem' },
        'py-px': { paddingTop: '1px', paddingBottom: '1px' },
        'px-px': { paddingLeft: '1px', paddingRight: '1px' },
        'pt-0': { paddingTop: '0' },
        'pr-0': { paddingRight: '0' },
        'pb-0': { paddingBottom: '0' },
        'pl-0': { paddingLeft: '0' },
        'pt-1': { paddingTop: '0.4rem' },
        'pr-1': { paddingRight: '0.4rem' },
        'pb-1': { paddingBottom: '0.4rem' },
        'pl-1': { paddingLeft: '0.4rem' },
        'pt-2': { paddingTop: '0.8rem' },
        'pr-2': { paddingRight: '0.8rem' },
        'pb-2': { paddingBottom: '0.8rem' },
        'pl-2': { paddingLeft: '0.8rem' },
        'pt-3': { paddingTop: '1.2rem' },
        'pr-3': { paddingRight: '1.2rem' },
        'pb-3': { paddingBottom: '1.2rem' },
        'pl-3': { paddingLeft: '1.2rem' },
        'pt-4': { paddingTop: '1.6rem' },
        'pr-4': { paddingRight: '1.6rem' },
        'pb-4': { paddingBottom: '1.6rem' },
        'pl-4': { paddingLeft: '1.6rem' },
        'pt-5': { paddingTop: '2rem' },
        'pr-5': { paddingRight: '2rem' },
        'pb-5': { paddingBottom: '2rem' },
        'pl-5': { paddingLeft: '2rem' },
        'pt-6': { paddingTop: '2.4rem' },
        'pr-6': { paddingRight: '2.4rem' },
        'pb-6': { paddingBottom: '2.4rem' },
        'pl-6': { paddingLeft: '2.4rem' },
        'pt-7': { paddingTop: '2.8rem' },
        'pr-7': { paddingRight: '2.8rem' },
        'pb-7': { paddingBottom: '2.8rem' },
        'pl-7': { paddingLeft: '2.8rem' },
        'pt-8': { paddingTop: '3.2rem' },
        'pr-8': { paddingRight: '3.2rem' },
        'pb-8': { paddingBottom: '3.2rem' },
        'pl-8': { paddingLeft: '3.2rem' },
        'pt-9': { paddingTop: '3.6rem' },
        'pr-9': { paddingRight: '3.6rem' },
        'pb-9': { paddingBottom: '3.6rem' },
        'pl-9': { paddingLeft: '3.6rem' },
        'pt-10': { paddingTop: '4rem' },
        'pr-10': { paddingRight: '4rem' },
        'pb-10': { paddingBottom: '4rem' },
        'pl-10': { paddingLeft: '4rem' },
        'pt-11': { paddingTop: '4.4rem' },
        'pr-11': { paddingRight: '4.4rem' },
        'pb-11': { paddingBottom: '4.4rem' },
        'pl-11': { paddingLeft: '4.4rem' },
        'pt-12': { paddingTop: '4.8rem' },
        'pr-12': { paddingRight: '4.8rem' },
        'pb-12': { paddingBottom: '4.8rem' },
        'pl-12': { paddingLeft: '4.8rem' },
        'pt-16': { paddingTop: '6.4rem' },
        'pr-16': { paddingRight: '6.4rem' },
        'pb-16': { paddingBottom: '6.4rem' },
        'pl-16': { paddingLeft: '6.4rem' },
        'pt-20': { paddingTop: '8rem' },
        'pr-20': { paddingRight: '8rem' },
        'pb-20': { paddingBottom: '8rem' },
        'pl-20': { paddingLeft: '8rem' },
        'pt-24': { paddingTop: '9.6rem' },
        'pr-24': { paddingRight: '9.6rem' },
        'pb-24': { paddingBottom: '9.6rem' },
        'pl-24': { paddingLeft: '9.6rem' },
        'pt-32': { paddingTop: '12.8rem' },
        'pr-32': { paddingRight: '12.8rem' },
        'pb-32': { paddingBottom: '12.8rem' },
        'pl-32': { paddingLeft: '12.8rem' },
        'pt-40': { paddingTop: '16rem' },
        'pr-40': { paddingRight: '16rem' },
        'pb-40': { paddingBottom: '16rem' },
        'pl-40': { paddingLeft: '16rem' },
        'pt-48': { paddingTop: '19.2rem' },
        'pr-48': { paddingRight: '19.2rem' },
        'pb-48': { paddingBottom: '19.2rem' },
        'pl-48': { paddingLeft: '19.2rem' },
        'pt-56': { paddingTop: '22.4rem' },
        'pr-56': { paddingRight: '22.4rem' },
        'pb-56': { paddingBottom: '22.4rem' },
        'pl-56': { paddingLeft: '22.4rem' },
        'pt-64': { paddingTop: '25.6rem' },
        'pr-64': { paddingRight: '25.6rem' },
        'pb-64': { paddingBottom: '25.6rem' },
        'pl-64': { paddingLeft: '25.6rem' },
        'pt-1.5': { paddingTop: '0.6rem' },
        'pr-1.5': { paddingRight: '0.6rem' },
        'pb-1.5': { paddingBottom: '0.6rem' },
        'pl-1.5': { paddingLeft: '0.6rem' },
        'pt-0.5': { paddingTop: '0.2rem' },
        'pr-0.5': { paddingRight: '0.2rem' },
        'pb-0.5': { paddingBottom: '0.2rem' },
        'pl-0.5': { paddingLeft: '0.2rem' },
        'pt-px': { paddingTop: '1px' },
        'pr-px': { paddingRight: '1px' },
        'pb-px': { paddingBottom: '1px' },
        'pl-px': { paddingLeft: '1px' },
        'stroke-current': { stroke: 'currentColor' },
        'stroke-0': { strokeWidth: '0' },
        'stroke-1': { strokeWidth: '1' },
        'stroke-2': { strokeWidth: '2' },
        'w-0': { width: '0' },
        'w-1': { width: '0.4rem' },
        'w-2': { width: '0.8rem' },
        'w-3': { width: '1.2rem' },
        'w-4': { width: '1.6rem' },
        'w-5': { width: '2rem' },
        'w-6': { width: '2.4rem' },
        'w-7': { width: '2.8rem' },
        'w-8': { width: '3.2rem' },
        'w-9': { width: '3.6rem' },
        'w-10': { width: '4rem' },
        'w-11': { width: '4.4rem' },
        'w-12': { width: '4.8rem' },
        'w-16': { width: '6.4rem' },
        'w-20': { width: '8rem' },
        'w-24': { width: '9.6rem' },
        'w-32': { width: '12.8rem' },
        'w-40': { width: '16rem' },
        'w-48': { width: '19.2rem' },
        'w-56': { width: '22.4rem' },
        'w-64': { width: '25.6rem' },
        'w-auto': { width: 'auto' },
        'w-px': { width: '1px' },
        'w-1/2': { width: '50%' },
        'w-1/3': { width: '33.333333%' },
        'w-1/4': { width: '25%' },
        'w-2/3': { width: '66.666667%' },
        'w-2/4': { width: '50%' },
        'w-3/4': { width: '75%' },
        'w-1/24': { width: '4.166667%' },
        'w-2/24': { width: '8.333333%' },
        'w-3/24': { width: '12.5%' },
        'w-4/24': { width: '16.666667%' },
        'w-5/24': { width: '20.833333%' },
        'w-6/24': { width: '25%' },
        'w-7/24': { width: '29.166667%' },
        'w-8/24': { width: '33.333333%' },
        'w-9/24': { width: '37.5%' },
        'w-10/24': { width: '41.666667%' },
        'w-11/24': { width: '45.833333%' },
        'w-12/24': { width: '50%' },
        'w-13/24': { width: '54.166667%' },
        'w-14/24': { width: '58.333333%' },
        'w-15/24': { width: '62.5%' },
        'w-16/24': { width: '66.666667%' },
        'w-17/24': { width: '70.833333%' },
        'w-18/24': { width: '75%' },
        'w-19/24': { width: '79.166667%' },
        'w-20/24': { width: '83.333333%' },
        'w-21/24': { width: '87.5%' },
        'w-22/24': { width: '91.666667%' },
        'w-23/24': { width: '95.833333%' },
        'w-full': { width: '100%' },
        'z-0': { zIndex: '0' },
        'z-10': { zIndex: '10' },
        'z-20': { zIndex: '20' },
        'z-30': { zIndex: '30' },
        'z-40': { zIndex: '40' },
        'z-50': { zIndex: '50' },
        'z-auto': { zIndex: 'auto' },
        'gap-0': { gridGap: '0', gap: '0' },
        'gap-1': { gridGap: '0.4rem', gap: '0.4rem' },
        'gap-2': { gridGap: '0.8rem', gap: '0.8rem' },
        'gap-3': { gridGap: '1.2rem', gap: '1.2rem' },
        'gap-4': { gridGap: '1.6rem', gap: '1.6rem' },
        'gap-5': { gridGap: '2rem', gap: '2rem' },
        'gap-6': { gridGap: '2.4rem', gap: '2.4rem' },
        'gap-7': { gridGap: '2.8rem', gap: '2.8rem' },
        'gap-8': { gridGap: '3.2rem', gap: '3.2rem' },
        'gap-9': { gridGap: '3.6rem', gap: '3.6rem' },
        'gap-10': { gridGap: '4rem', gap: '4rem' },
        'gap-11': { gridGap: '4.4rem', gap: '4.4rem' },
        'gap-12': { gridGap: '4.8rem', gap: '4.8rem' },
        'gap-16': { gridGap: '6.4rem', gap: '6.4rem' },
        'gap-20': { gridGap: '8rem', gap: '8rem' },
        'gap-24': { gridGap: '9.6rem', gap: '9.6rem' },
        'gap-32': { gridGap: '12.8rem', gap: '12.8rem' },
        'gap-40': { gridGap: '16rem', gap: '16rem' },
        'gap-48': { gridGap: '19.2rem', gap: '19.2rem' },
        'gap-56': { gridGap: '22.4rem', gap: '22.4rem' },
        'gap-64': { gridGap: '25.6rem', gap: '25.6rem' },
        'gap-px': { gridGap: '1px', gap: '1px' },
        'gap-x-0': { gridColumnGap: '0', columnGap: '0' },
        'gap-x-1': { gridColumnGap: '0.4rem', columnGap: '0.4rem' },
        'gap-x-2': { gridColumnGap: '0.8rem', columnGap: '0.8rem' },
        'gap-x-3': { gridColumnGap: '1.2rem', columnGap: '1.2rem' },
        'gap-x-4': { gridColumnGap: '1.6rem', columnGap: '1.6rem' },
        'gap-x-5': { gridColumnGap: '2rem', columnGap: '2rem' },
        'gap-x-6': { gridColumnGap: '2.4rem', columnGap: '2.4rem' },
        'gap-x-7': { gridColumnGap: '2.8rem', columnGap: '2.8rem' },
        'gap-x-8': { gridColumnGap: '3.2rem', columnGap: '3.2rem' },
        'gap-x-9': { gridColumnGap: '3.6rem', columnGap: '3.6rem' },
        'gap-x-10': { gridColumnGap: '4rem', columnGap: '4rem' },
        'gap-x-11': { gridColumnGap: '4.4rem', columnGap: '4.4rem' },
        'gap-x-12': { gridColumnGap: '4.8rem', columnGap: '4.8rem' },
        'gap-x-16': { gridColumnGap: '6.4rem', columnGap: '6.4rem' },
        'gap-x-20': { gridColumnGap: '8rem', columnGap: '8rem' },
        'gap-x-24': { gridColumnGap: '9.6rem', columnGap: '9.6rem' },
        'gap-x-32': { gridColumnGap: '12.8rem', columnGap: '12.8rem' },
        'gap-x-40': { gridColumnGap: '16rem', columnGap: '16rem' },
        'gap-x-48': { gridColumnGap: '19.2rem', columnGap: '19.2rem' },
        'gap-x-56': { gridColumnGap: '22.4rem', columnGap: '22.4rem' },
        'gap-x-64': { gridColumnGap: '25.6rem', columnGap: '25.6rem' },
        'gap-x-px': { gridColumnGap: '1px', columnGap: '1px' },
        'gap-y-0': { gridRowGap: '0', rowGap: '0' },
        'gap-y-1': { gridRowGap: '0.4rem', rowGap: '0.4rem' },
        'gap-y-2': { gridRowGap: '0.8rem', rowGap: '0.8rem' },
        'gap-y-3': { gridRowGap: '1.2rem', rowGap: '1.2rem' },
        'gap-y-4': { gridRowGap: '1.6rem', rowGap: '1.6rem' },
        'gap-y-5': { gridRowGap: '2rem', rowGap: '2rem' },
        'gap-y-6': { gridRowGap: '2.4rem', rowGap: '2.4rem' },
        'gap-y-7': { gridRowGap: '2.8rem', rowGap: '2.8rem' },
        'gap-y-8': { gridRowGap: '3.2rem', rowGap: '3.2rem' },
        'gap-y-9': { gridRowGap: '3.6rem', rowGap: '3.6rem' },
        'gap-y-10': { gridRowGap: '4rem', rowGap: '4rem' },
        'gap-y-11': { gridRowGap: '4.4rem', rowGap: '4.4rem' },
        'gap-y-12': { gridRowGap: '4.8rem', rowGap: '4.8rem' },
        'gap-y-16': { gridRowGap: '6.4rem', rowGap: '6.4rem' },
        'gap-y-20': { gridRowGap: '8rem', rowGap: '8rem' },
        'gap-y-24': { gridRowGap: '9.6rem', rowGap: '9.6rem' },
        'gap-y-32': { gridRowGap: '12.8rem', rowGap: '12.8rem' },
        'gap-y-40': { gridRowGap: '16rem', rowGap: '16rem' },
        'gap-y-48': { gridRowGap: '19.2rem', rowGap: '19.2rem' },
        'gap-y-56': { gridRowGap: '22.4rem', rowGap: '22.4rem' },
        'gap-y-64': { gridRowGap: '25.6rem', rowGap: '25.6rem' },
        'gap-y-px': { gridRowGap: '1px', rowGap: '1px' },
        'grid-cols-1': { gridTemplateColumns: 'repeat(1, minmax(0, 1fr))' },
        'grid-cols-2': { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
        'grid-cols-3': { gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' },
        'grid-cols-4': { gridTemplateColumns: 'repeat(4, minmax(0, 1fr))' },
        'grid-cols-5': { gridTemplateColumns: 'repeat(5, minmax(0, 1fr))' },
        'grid-cols-6': { gridTemplateColumns: 'repeat(6, minmax(0, 1fr))' },
        'grid-cols-7': { gridTemplateColumns: 'repeat(7, minmax(0, 1fr))' },
        'grid-cols-8': { gridTemplateColumns: 'repeat(8, minmax(0, 1fr))' },
        'grid-cols-9': { gridTemplateColumns: 'repeat(9, minmax(0, 1fr))' },
        'grid-cols-10': { gridTemplateColumns: 'repeat(10, minmax(0, 1fr))' },
        'grid-cols-11': { gridTemplateColumns: 'repeat(11, minmax(0, 1fr))' },
        'grid-cols-12': { gridTemplateColumns: 'repeat(12, minmax(0, 1fr))' },
        'grid-cols-13': { gridTemplateColumns: 'repeat(13, minmax(0, 1fr))' },
        'grid-cols-14': { gridTemplateColumns: 'repeat(14, minmax(0, 1fr))' },
        'grid-cols-15': { gridTemplateColumns: 'repeat(15, minmax(0, 1fr))' },
        'grid-cols-16': { gridTemplateColumns: 'repeat(16, minmax(0, 1fr))' },
        'grid-cols-17': { gridTemplateColumns: 'repeat(17, minmax(0, 1fr))' },
        'grid-cols-18': { gridTemplateColumns: 'repeat(18, minmax(0, 1fr))' },
        'grid-cols-19': { gridTemplateColumns: 'repeat(19, minmax(0, 1fr))' },
        'grid-cols-20': { gridTemplateColumns: 'repeat(20, minmax(0, 1fr))' },
        'grid-cols-21': { gridTemplateColumns: 'repeat(21, minmax(0, 1fr))' },
        'grid-cols-22': { gridTemplateColumns: 'repeat(22, minmax(0, 1fr))' },
        'grid-cols-23': { gridTemplateColumns: 'repeat(23, minmax(0, 1fr))' },
        'grid-cols-24': { gridTemplateColumns: 'repeat(24, minmax(0, 1fr))' },
        'grid-cols-none': { gridTemplateColumns: 'none' },
        'col-auto': { gridColumn: 'auto' },
        'col-span-1': { gridColumn: 'span 1 / span 1' },
        'col-span-2': { gridColumn: 'span 2 / span 2' },
        'col-span-3': { gridColumn: 'span 3 / span 3' },
        'col-span-4': { gridColumn: 'span 4 / span 4' },
        'col-span-5': { gridColumn: 'span 5 / span 5' },
        'col-span-6': { gridColumn: 'span 6 / span 6' },
        'col-span-7': { gridColumn: 'span 7 / span 7' },
        'col-span-8': { gridColumn: 'span 8 / span 8' },
        'col-span-9': { gridColumn: 'span 9 / span 9' },
        'col-span-10': { gridColumn: 'span 10 / span 10' },
        'col-span-11': { gridColumn: 'span 11 / span 11' },
        'col-span-12': { gridColumn: 'span 12 / span 12' },
        'col-span-13': { gridColumn: 'span 13 / span 13' },
        'col-span-14': { gridColumn: 'span 14 / span 14' },
        'col-span-15': { gridColumn: 'span 15 / span 15' },
        'col-span-16': { gridColumn: 'span 16 / span 16' },
        'col-span-17': { gridColumn: 'span 17 / span 17' },
        'col-span-18': { gridColumn: 'span 18 / span 18' },
        'col-span-19': { gridColumn: 'span 19 / span 19' },
        'col-span-20': { gridColumn: 'span 20 / span 20' },
        'col-span-21': { gridColumn: 'span 21 / span 21' },
        'col-span-22': { gridColumn: 'span 22 / span 22' },
        'col-span-23': { gridColumn: 'span 23 / span 23' },
        'col-span-24': { gridColumn: 'span 24 / span 24' },
        'col-start-1': { gridColumnStart: '1' },
        'col-start-2': { gridColumnStart: '2' },
        'col-start-3': { gridColumnStart: '3' },
        'col-start-4': { gridColumnStart: '4' },
        'col-start-5': { gridColumnStart: '5' },
        'col-start-6': { gridColumnStart: '6' },
        'col-start-7': { gridColumnStart: '7' },
        'col-start-8': { gridColumnStart: '8' },
        'col-start-9': { gridColumnStart: '9' },
        'col-start-10': { gridColumnStart: '10' },
        'col-start-11': { gridColumnStart: '11' },
        'col-start-12': { gridColumnStart: '12' },
        'col-start-13': { gridColumnStart: '13' },
        'col-start-14': { gridColumnStart: '14' },
        'col-start-15': { gridColumnStart: '15' },
        'col-start-16': { gridColumnStart: '16' },
        'col-start-17': { gridColumnStart: '17' },
        'col-start-18': { gridColumnStart: '18' },
        'col-start-19': { gridColumnStart: '19' },
        'col-start-20': { gridColumnStart: '20' },
        'col-start-21': { gridColumnStart: '21' },
        'col-start-22': { gridColumnStart: '22' },
        'col-start-23': { gridColumnStart: '23' },
        'col-start-24': { gridColumnStart: '24' },
        'col-start-auto': { gridColumnStart: 'auto' },
        'col-end-1': { gridColumnEnd: '1' },
        'col-end-2': { gridColumnEnd: '2' },
        'col-end-3': { gridColumnEnd: '3' },
        'col-end-4': { gridColumnEnd: '4' },
        'col-end-5': { gridColumnEnd: '5' },
        'col-end-6': { gridColumnEnd: '6' },
        'col-end-7': { gridColumnEnd: '7' },
        'col-end-8': { gridColumnEnd: '8' },
        'col-end-9': { gridColumnEnd: '9' },
        'col-end-10': { gridColumnEnd: '10' },
        'col-end-11': { gridColumnEnd: '11' },
        'col-end-12': { gridColumnEnd: '12' },
        'col-end-13': { gridColumnEnd: '13' },
        'col-end-14': { gridColumnEnd: '14' },
        'col-end-15': { gridColumnEnd: '15' },
        'col-end-16': { gridColumnEnd: '16' },
        'col-end-17': { gridColumnEnd: '17' },
        'col-end-18': { gridColumnEnd: '18' },
        'col-end-19': { gridColumnEnd: '19' },
        'col-end-20': { gridColumnEnd: '20' },
        'col-end-21': { gridColumnEnd: '21' },
        'col-end-22': { gridColumnEnd: '22' },
        'col-end-23': { gridColumnEnd: '23' },
        'col-end-24': { gridColumnEnd: '24' },
        'col-end-auto': { gridColumnEnd: 'auto' },
        'grid-rows-1': { gridTemplateRows: 'repeat(1, minmax(0, 1fr))' },
        'grid-rows-2': { gridTemplateRows: 'repeat(2, minmax(0, 1fr))' },
        'grid-rows-3': { gridTemplateRows: 'repeat(3, minmax(0, 1fr))' },
        'grid-rows-4': { gridTemplateRows: 'repeat(4, minmax(0, 1fr))' },
        'grid-rows-5': { gridTemplateRows: 'repeat(5, minmax(0, 1fr))' },
        'grid-rows-6': { gridTemplateRows: 'repeat(6, minmax(0, 1fr))' },
        'grid-rows-7': { gridTemplateRows: 'repeat(7, minmax(0, 1fr))' },
        'grid-rows-8': { gridTemplateRows: 'repeat(8, minmax(0, 1fr))' },
        'grid-rows-9': { gridTemplateRows: 'repeat(9, minmax(0, 1fr))' },
        'grid-rows-10': { gridTemplateRows: 'repeat(10, minmax(0, 1fr))' },
        'grid-rows-11': { gridTemplateRows: 'repeat(11, minmax(0, 1fr))' },
        'grid-rows-12': { gridTemplateRows: 'repeat(12, minmax(0, 1fr))' },
        'grid-rows-none': { gridTemplateRows: 'none' },
        'row-auto': { gridRow: 'auto' },
        'row-span-1': { gridRow: 'span 1 / span 1' },
        'row-span-2': { gridRow: 'span 2 / span 2' },
        'row-span-3': { gridRow: 'span 3 / span 3' },
        'row-span-4': { gridRow: 'span 4 / span 4' },
        'row-span-5': { gridRow: 'span 5 / span 5' },
        'row-span-6': { gridRow: 'span 6 / span 6' },
        'row-span-7': { gridRow: 'span 7 / span 7' },
        'row-span-8': { gridRow: 'span 8 / span 8' },
        'row-span-9': { gridRow: 'span 9 / span 9' },
        'row-span-10': { gridRow: 'span 10 / span 10' },
        'row-span-11': { gridRow: 'span 11 / span 11' },
        'row-span-12': { gridRow: 'span 12 / span 12' },
        'row-start-1': { gridRowStart: '1' },
        'row-start-2': { gridRowStart: '2' },
        'row-start-3': { gridRowStart: '3' },
        'row-start-4': { gridRowStart: '4' },
        'row-start-5': { gridRowStart: '5' },
        'row-start-6': { gridRowStart: '6' },
        'row-start-7': { gridRowStart: '7' },
        'row-start-8': { gridRowStart: '8' },
        'row-start-9': { gridRowStart: '9' },
        'row-start-10': { gridRowStart: '10' },
        'row-start-11': { gridRowStart: '11' },
        'row-start-12': { gridRowStart: '12' },
        'row-start-13': { gridRowStart: '13' },
        'row-start-auto': { gridRowStart: 'auto' },
        'row-end-1': { gridRowEnd: '1' },
        'row-end-2': { gridRowEnd: '2' },
        'row-end-3': { gridRowEnd: '3' },
        'row-end-4': { gridRowEnd: '4' },
        'row-end-5': { gridRowEnd: '5' },
        'row-end-6': { gridRowEnd: '6' },
        'row-end-7': { gridRowEnd: '7' },
        'row-end-8': { gridRowEnd: '8' },
        'row-end-9': { gridRowEnd: '9' },
        'row-end-10': { gridRowEnd: '10' },
        'row-end-11': { gridRowEnd: '11' },
        'row-end-12': { gridRowEnd: '12' },
        'row-end-13': { gridRowEnd: '13' },
        'row-end-auto': { gridRowEnd: 'auto' },
        'origin-center': { transformOrigin: 'center' },
        'origin-top': { transformOrigin: 'top' },
        'origin-top-right': { transformOrigin: 'top right' },
        'origin-right': { transformOrigin: 'right' },
        'origin-bottom-right': { transformOrigin: 'bottom right' },
        'origin-bottom': { transformOrigin: 'bottom' },
        'origin-bottom-left': { transformOrigin: 'bottom left' },
        'origin-left': { transformOrigin: 'left' },
        'origin-top-left': { transformOrigin: 'top left' },
        'scale-0': { '-TransformScaleX': '0', '-TransformScaleY': '0' },
        'scale-50': { '-TransformScaleX': '.5', '-TransformScaleY': '.5' },
        'scale-75': { '-TransformScaleX': '.75', '-TransformScaleY': '.75' },
        'scale-90': { '-TransformScaleX': '.9', '-TransformScaleY': '.9' },
        'scale-95': { '-TransformScaleX': '.95', '-TransformScaleY': '.95' },
        'scale-100': { '-TransformScaleX': '1', '-TransformScaleY': '1' },
        'scale-105': { '-TransformScaleX': '1.05', '-TransformScaleY': '1.05' },
        'scale-110': { '-TransformScaleX': '1.1', '-TransformScaleY': '1.1' },
        'scale-125': { '-TransformScaleX': '1.25', '-TransformScaleY': '1.25' },
        'scale-150': { '-TransformScaleX': '1.5', '-TransformScaleY': '1.5' },
        'scale-x-0': { '-TransformScaleX': '0' },
        'scale-x-50': { '-TransformScaleX': '.5' },
        'scale-x-75': { '-TransformScaleX': '.75' },
        'scale-x-90': { '-TransformScaleX': '.9' },
        'scale-x-95': { '-TransformScaleX': '.95' },
        'scale-x-100': { '-TransformScaleX': '1' },
        'scale-x-105': { '-TransformScaleX': '1.05' },
        'scale-x-110': { '-TransformScaleX': '1.1' },
        'scale-x-125': { '-TransformScaleX': '1.25' },
        'scale-x-150': { '-TransformScaleX': '1.5' },
        'scale-y-0': { '-TransformScaleY': '0' },
        'scale-y-50': { '-TransformScaleY': '.5' },
        'scale-y-75': { '-TransformScaleY': '.75' },
        'scale-y-90': { '-TransformScaleY': '.9' },
        'scale-y-95': { '-TransformScaleY': '.95' },
        'scale-y-100': { '-TransformScaleY': '1' },
        'scale-y-105': { '-TransformScaleY': '1.05' },
        'scale-y-110': { '-TransformScaleY': '1.1' },
        'scale-y-125': { '-TransformScaleY': '1.25' },
        'scale-y-150': { '-TransformScaleY': '1.5' },
        'rotate-0': { '-TransformRotate': '0' },
        'rotate-45': { '-TransformRotate': '45deg' },
        'rotate-90': { '-TransformRotate': '90deg' },
        'rotate-180': { '-TransformRotate': '180deg' },
        '-rotate-180': { '-TransformRotate': '-180deg' },
        '-rotate-90': { '-TransformRotate': '-90deg' },
        '-rotate-45': { '-TransformRotate': '-45deg' },
        'translate-x-0': { '-TransformTranslateX': '0' },
        'translate-x-1': { '-TransformTranslateX': '0.4rem' },
        'translate-x-2': { '-TransformTranslateX': '0.8rem' },
        'translate-x-3': { '-TransformTranslateX': '1.2rem' },
        'translate-x-4': { '-TransformTranslateX': '1.6rem' },
        'translate-x-5': { '-TransformTranslateX': '2rem' },
        'translate-x-6': { '-TransformTranslateX': '2.4rem' },
        'translate-x-7': { '-TransformTranslateX': '2.8rem' },
        'translate-x-8': { '-TransformTranslateX': '3.2rem' },
        'translate-x-9': { '-TransformTranslateX': '3.6rem' },
        'translate-x-10': { '-TransformTranslateX': '4rem' },
        'translate-x-11': { '-TransformTranslateX': '4.4rem' },
        'translate-x-12': { '-TransformTranslateX': '4.8rem' },
        'translate-x-16': { '-TransformTranslateX': '6.4rem' },
        'translate-x-20': { '-TransformTranslateX': '8rem' },
        'translate-x-24': { '-TransformTranslateX': '9.6rem' },
        'translate-x-32': { '-TransformTranslateX': '12.8rem' },
        'translate-x-40': { '-TransformTranslateX': '16rem' },
        'translate-x-48': { '-TransformTranslateX': '19.2rem' },
        'translate-x-56': { '-TransformTranslateX': '22.4rem' },
        'translate-x-64': { '-TransformTranslateX': '25.6rem' },
        'translate-x-px': { '-TransformTranslateX': '1px' },
        '-translate-x-1': { '-TransformTranslateX': '-0.4rem' },
        '-translate-x-2': { '-TransformTranslateX': '-0.8rem' },
        '-translate-x-3': { '-TransformTranslateX': '-1.2rem' },
        '-translate-x-4': { '-TransformTranslateX': '-1.6rem' },
        '-translate-x-5': { '-TransformTranslateX': '-2rem' },
        '-translate-x-6': { '-TransformTranslateX': '-2.4rem' },
        '-translate-x-7': { '-TransformTranslateX': '-2.8rem' },
        '-translate-x-8': { '-TransformTranslateX': '-3.2rem' },
        '-translate-x-9': { '-TransformTranslateX': '-3.6rem' },
        '-translate-x-10': { '-TransformTranslateX': '-4rem' },
        '-translate-x-11': { '-TransformTranslateX': '-4.4rem' },
        '-translate-x-12': { '-TransformTranslateX': '-4.8rem' },
        '-translate-x-16': { '-TransformTranslateX': '-6.4rem' },
        '-translate-x-20': { '-TransformTranslateX': '-8rem' },
        '-translate-x-24': { '-TransformTranslateX': '-9.6rem' },
        '-translate-x-32': { '-TransformTranslateX': '-12.8rem' },
        '-translate-x-40': { '-TransformTranslateX': '-16rem' },
        '-translate-x-48': { '-TransformTranslateX': '-19.2rem' },
        '-translate-x-56': { '-TransformTranslateX': '-22.4rem' },
        '-translate-x-64': { '-TransformTranslateX': '-25.6rem' },
        '-translate-x-px': { '-TransformTranslateX': '-1px' },
        '-translate-x-full': { '-TransformTranslateX': '-100%' },
        '-translate-x-1/2': { '-TransformTranslateX': '-50%' },
        'translate-x-1/2': { '-TransformTranslateX': '50%' },
        'translate-x-full': { '-TransformTranslateX': '100%' },
        'translate-y-0': { '-TransformTranslateY': '0' },
        'translate-y-1': { '-TransformTranslateY': '0.4rem' },
        'translate-y-2': { '-TransformTranslateY': '0.8rem' },
        'translate-y-3': { '-TransformTranslateY': '1.2rem' },
        'translate-y-4': { '-TransformTranslateY': '1.6rem' },
        'translate-y-5': { '-TransformTranslateY': '2rem' },
        'translate-y-6': { '-TransformTranslateY': '2.4rem' },
        'translate-y-7': { '-TransformTranslateY': '2.8rem' },
        'translate-y-8': { '-TransformTranslateY': '3.2rem' },
        'translate-y-9': { '-TransformTranslateY': '3.6rem' },
        'translate-y-10': { '-TransformTranslateY': '4rem' },
        'translate-y-11': { '-TransformTranslateY': '4.4rem' },
        'translate-y-12': { '-TransformTranslateY': '4.8rem' },
        'translate-y-16': { '-TransformTranslateY': '6.4rem' },
        'translate-y-20': { '-TransformTranslateY': '8rem' },
        'translate-y-24': { '-TransformTranslateY': '9.6rem' },
        'translate-y-32': { '-TransformTranslateY': '12.8rem' },
        'translate-y-40': { '-TransformTranslateY': '16rem' },
        'translate-y-48': { '-TransformTranslateY': '19.2rem' },
        'translate-y-56': { '-TransformTranslateY': '22.4rem' },
        'translate-y-64': { '-TransformTranslateY': '25.6rem' },
        'translate-y-px': { '-TransformTranslateY': '1px' },
        '-translate-y-1': { '-TransformTranslateY': '-0.4rem' },
        '-translate-y-2': { '-TransformTranslateY': '-0.8rem' },
        '-translate-y-3': { '-TransformTranslateY': '-1.2rem' },
        '-translate-y-4': { '-TransformTranslateY': '-1.6rem' },
        '-translate-y-5': { '-TransformTranslateY': '-2rem' },
        '-translate-y-6': { '-TransformTranslateY': '-2.4rem' },
        '-translate-y-7': { '-TransformTranslateY': '-2.8rem' },
        '-translate-y-8': { '-TransformTranslateY': '-3.2rem' },
        '-translate-y-9': { '-TransformTranslateY': '-3.6rem' },
        '-translate-y-10': { '-TransformTranslateY': '-4rem' },
        '-translate-y-11': { '-TransformTranslateY': '-4.4rem' },
        '-translate-y-12': { '-TransformTranslateY': '-4.8rem' },
        '-translate-y-16': { '-TransformTranslateY': '-6.4rem' },
        '-translate-y-20': { '-TransformTranslateY': '-8rem' },
        '-translate-y-24': { '-TransformTranslateY': '-9.6rem' },
        '-translate-y-32': { '-TransformTranslateY': '-12.8rem' },
        '-translate-y-40': { '-TransformTranslateY': '-16rem' },
        '-translate-y-48': { '-TransformTranslateY': '-19.2rem' },
        '-translate-y-56': { '-TransformTranslateY': '-22.4rem' },
        '-translate-y-64': { '-TransformTranslateY': '-25.6rem' },
        '-translate-y-px': { '-TransformTranslateY': '-1px' },
        '-translate-y-full': { '-TransformTranslateY': '-100%' },
        '-translate-y-1/2': { '-TransformTranslateY': '-50%' },
        'translate-y-1/2': { '-TransformTranslateY': '50%' },
        'translate-y-full': { '-TransformTranslateY': '100%' },
        'skew-x-0': { '-TransformSkewX': '0' },
        'skew-x-3': { '-TransformSkewX': '3deg' },
        'skew-x-6': { '-TransformSkewX': '6deg' },
        'skew-x-12': { '-TransformSkewX': '12deg' },
        '-skew-x-12': { '-TransformSkewX': '-12deg' },
        '-skew-x-6': { '-TransformSkewX': '-6deg' },
        '-skew-x-3': { '-TransformSkewX': '-3deg' },
        'skew-y-0': { '-TransformSkewY': '0' },
        'skew-y-3': { '-TransformSkewY': '3deg' },
        'skew-y-6': { '-TransformSkewY': '6deg' },
        'skew-y-12': { '-TransformSkewY': '12deg' },
        '-skew-y-12': { '-TransformSkewY': '-12deg' },
        '-skew-y-6': { '-TransformSkewY': '-6deg' },
        '-skew-y-3': { '-TransformSkewY': '-3deg' },
        'transition-none': { transitionProperty: 'none' },
        'transition-all': { transitionProperty: 'all' },
        transition: {
            transitionProperty: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform'
        },
        'transition-colors': { transitionProperty: 'background-color, border-color, color, fill, stroke' },
        'transition-opacity': { transitionProperty: 'opacity' },
        'transition-shadow': { transitionProperty: 'box-shadow' },
        'transition-transform': { transitionProperty: 'transform' },
        'ease-linear': { transitionTimingFunction: 'linear' },
        'ease-in': { transitionTimingFunction: 'cubic-bezier(0.4, 0, 1, 1)' },
        'ease-out': { transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)' },
        'ease-in-out': { transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' },
        'duration-75': { transitionDuration: '75ms' },
        'duration-100': { transitionDuration: '100ms' },
        'duration-150': { transitionDuration: '150ms' },
        'duration-200': { transitionDuration: '200ms' },
        'duration-300': { transitionDuration: '300ms' },
        'duration-500': { transitionDuration: '500ms' },
        'duration-700': { transitionDuration: '700ms' },
        'duration-1000': { transitionDuration: '1000ms' },
        'border-transparent': { borderColor: 'transparent' },
        'border-current': { borderColor: 'currentColor' },
        'border-opacity-0': { '-BorderOpacity': '0' },
        'border-opacity-5': { '-BorderOpacity': '0.05' },
        'border-opacity-10': { '-BorderOpacity': '0.1' },
        'border-opacity-15': { '-BorderOpacity': '0.15' },
        'border-opacity-20': { '-BorderOpacity': '0.2' },
        'border-opacity-25': { '-BorderOpacity': '0.25' },
        'border-opacity-30': { '-BorderOpacity': '0.3' },
        'border-opacity-40': { '-BorderOpacity': '0.4' },
        'border-opacity-50': { '-BorderOpacity': '0.5' },
        'border-opacity-60': { '-BorderOpacity': '0.6' },
        'border-opacity-70': { '-BorderOpacity': '0.7' },
        'border-opacity-75': { '-BorderOpacity': '0.75' },
        'border-opacity-80': { '-BorderOpacity': '0.8' },
        'border-opacity-90': { '-BorderOpacity': '0.9' },
        'border-opacity-100': { '-BorderOpacity': '1' },
        'placeholder-transparent::placeholder': { color: 'transparent' },
        'placeholder-current::placeholder': { color: 'currentColor' },
        'placeholder-opacity-0::placeholder': { '-PlaceholderOpacity': '0' },
        'placeholder-opacity-5::placeholder': { '-PlaceholderOpacity': '0.05' },
        'placeholder-opacity-10::placeholder': { '-PlaceholderOpacity': '0.1' },
        'placeholder-opacity-15::placeholder': { '-PlaceholderOpacity': '0.15' },
        'placeholder-opacity-20::placeholder': { '-PlaceholderOpacity': '0.2' },
        'placeholder-opacity-25::placeholder': { '-PlaceholderOpacity': '0.25' },
        'placeholder-opacity-30::placeholder': { '-PlaceholderOpacity': '0.3' },
        'placeholder-opacity-40::placeholder': { '-PlaceholderOpacity': '0.4' },
        'placeholder-opacity-50::placeholder': { '-PlaceholderOpacity': '0.5' },
        'placeholder-opacity-60::placeholder': { '-PlaceholderOpacity': '0.6' },
        'placeholder-opacity-70::placeholder': { '-PlaceholderOpacity': '0.7' },
        'placeholder-opacity-75::placeholder': { '-PlaceholderOpacity': '0.75' },
        'placeholder-opacity-80::placeholder': { '-PlaceholderOpacity': '0.8' },
        'placeholder-opacity-90::placeholder': { '-PlaceholderOpacity': '0.9' },
        'placeholder-opacity-100::placeholder': { '-PlaceholderOpacity': '1' },
        'text-transparent': { color: 'transparent' },
        'text-current': { color: 'currentColor' },
        'delay-75': { transitionDelay: '75ms' },
        'delay-100': { transitionDelay: '100ms' },
        'delay-150': { transitionDelay: '150ms' },
        'delay-200': { transitionDelay: '200ms' },
        'delay-300': { transitionDelay: '300ms' },
        'delay-500': { transitionDelay: '500ms' },
        'delay-700': { transitionDelay: '700ms' },
        'delay-1000': { transitionDelay: '1000ms' },
        'text-10': { fontSize: '1rem' },
        'text-11': { fontSize: '1.1rem' },
        'text-12': { fontSize: '1.2rem' },
        'text-13': { fontSize: '1.3rem' },
        'text-14': { fontSize: '1.4rem' },
        'text-16': { fontSize: '1.6rem' },
        'text-20': { fontSize: '2rem' },
        'text-24': { fontSize: '2.4rem' },
        'text-32': { fontSize: '3.2rem' },
        'text-40': { fontSize: '4rem' },
        'text-56': { fontSize: '5.6rem' },
        'text-72': { fontSize: '7.2rem' },
        'sr-only': {
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: '0',
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            borderWidth: '0'
        },
        'not-sr-only': {
            position: 'static',
            width: 'auto',
            height: 'auto',
            padding: '0',
            margin: '0',
            overflow: 'visible',
            clip: 'auto',
            whiteSpace: 'normal'
        },
        'content-center': { alignContent: 'center' },
        'content-start': { alignContent: 'flex-start' },
        'content-end': { alignContent: 'flex-end' },
        'content-between': { alignContent: 'space-between' },
        'content-around': { alignContent: 'space-around' },
        'content-evenly': { alignContent: 'space-evenly' },
        'items-start': { alignItems: 'flex-start' },
        'items-end': { alignItems: 'flex-end' },
        'items-center': { alignItems: 'center' },
        'items-baseline': { alignItems: 'baseline' },
        'items-stretch': { alignItems: 'stretch' },
        'self-auto': { alignSelf: 'auto' },
        'self-start': { alignSelf: 'flex-start' },
        'self-end': { alignSelf: 'flex-end' },
        'self-center': { alignSelf: 'center' },
        'self-stretch': { alignSelf: 'stretch' },
        'appearance-none': { appearance: 'none' },
        'border-solid': { borderStyle: 'solid' },
        'border-dashed': { borderStyle: 'dashed' },
        'border-dotted': { borderStyle: 'dotted' },
        'border-double': { borderStyle: 'double' },
        'border-none': { borderStyle: 'none' },
        'box-border': { boxSizing: 'border-box' },
        'box-content': { boxSizing: 'content-box' },
        'bg-fixed': { backgroundAttachment: 'fixed' },
        'bg-local': { backgroundAttachment: 'local' },
        'bg-scroll': { backgroundAttachment: 'scroll' },
        'bg-repeat': { backgroundRepeat: 'repeat' },
        'bg-no-repeat': { backgroundRepeat: 'no-repeat' },
        'bg-repeat-x': { backgroundRepeat: 'repeat-x' },
        'bg-repeat-y': { backgroundRepeat: 'repeat-y' },
        'bg-repeat-round': { backgroundRepeat: 'round' },
        'bg-repeat-space': { backgroundRepeat: 'space' },
        'border-collapse': { borderCollapse: 'collapse' },
        'border-separate': { borderCollapse: 'separate' },
        'clear-left': { clear: 'left' },
        'clear-right': { clear: 'right' },
        'clear-both': { clear: 'both' },
        'clear-none': { clear: 'none' },
        block: { display: 'block' },
        'inline-block': { display: 'inline-block' },
        inline: { display: 'inline' },
        flex: { display: 'flex' },
        'inline-flex': { display: 'inline-flex' },
        table: { display: 'table' },
        'table-caption': { display: 'table-caption' },
        'table-cell': { display: 'table-cell' },
        'table-column': { display: 'table-column' },
        'table-column-group': { display: 'table-column-group' },
        'table-footer-group': { display: 'table-footer-group' },
        'table-header-group': { display: 'table-header-group' },
        'table-row-group': { display: 'table-row-group' },
        'table-row': { display: 'table-row' },
        'flow-root': { display: 'flow-root' },
        grid: { display: 'grid' },
        'inline-grid': { display: 'inline-grid' },
        contents: { display: 'contents' },
        hidden: { display: 'none' },
        'flex-row': { flexDirection: 'row' },
        'flex-row-reverse': { flexDirection: 'row-reverse' },
        'flex-col': { flexDirection: 'column' },
        'flex-col-reverse': { flexDirection: 'column-reverse' },
        'flex-wrap': { flexWrap: 'wrap' },
        'flex-wrap-reverse': { flexWrap: 'wrap-reverse' },
        'flex-no-wrap': { flexWrap: 'nowrap' },
        'float-right': { float: 'right' },
        'float-left': { float: 'left' },
        'float-none': { float: 'none' },
        'clearfix:after': { content: '""', display: 'table', clear: 'both' },
        antialiased: { WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale' },
        'subpixel-antialiased': { WebkitFontSmoothing: 'auto', MozOsxFontSmoothing: 'auto' },
        italic: { fontStyle: 'italic' },
        'not-italic': { fontStyle: 'normal' },
        'grid-flow-row': { gridAutoFlow: 'row' },
        'grid-flow-col': { gridAutoFlow: 'column' },
        'grid-flow-row-dense': { gridAutoFlow: 'row dense' },
        'grid-flow-col-dense': { gridAutoFlow: 'column dense' },
        'justify-start': { justifyContent: 'flex-start' },
        'justify-end': { justifyContent: 'flex-end' },
        'justify-center': { justifyContent: 'center' },
        'justify-between': { justifyContent: 'space-between' },
        'justify-around': { justifyContent: 'space-around' },
        'justify-evenly': { justifyContent: 'space-evenly' },
        'list-inside': { listStylePosition: 'inside' },
        'list-outside': { listStylePosition: 'outside' },
        'object-contain': { objectFit: 'contain' },
        'object-cover': { objectFit: 'cover' },
        'object-fill': { objectFit: 'fill' },
        'object-none': { objectFit: 'none' },
        'object-scale-down': { objectFit: 'scale-down' },
        'overflow-auto': { overflow: 'auto' },
        'overflow-hidden': { overflow: 'hidden' },
        'overflow-visible': { overflow: 'visible' },
        'overflow-scroll': { overflow: 'scroll' },
        'overflow-x-auto': { overflowX: 'auto' },
        'overflow-y-auto': { overflowY: 'auto' },
        'overflow-x-hidden': { overflowX: 'hidden' },
        'overflow-y-hidden': { overflowY: 'hidden' },
        'overflow-x-visible': { overflowX: 'visible' },
        'overflow-y-visible': { overflowY: 'visible' },
        'overflow-x-scroll': { overflowX: 'scroll' },
        'overflow-y-scroll': { overflowY: 'scroll' },
        'scrolling-touch': { WebkitOverflowScrolling: 'touch' },
        'scrolling-auto': { WebkitOverflowScrolling: 'auto' },
        'pointer-events-none': { pointerEvents: 'none' },
        'pointer-events-auto': { pointerEvents: 'auto' },
        static: { position: 'static' },
        fixed: { position: 'fixed' },
        absolute: { position: 'absolute' },
        relative: { position: 'relative' },
        sticky: { position: 'sticky' },
        'resize-none': { resize: 'none' },
        'resize-y': { resize: 'vertical' },
        'resize-x': { resize: 'horizontal' },
        resize: { resize: 'both' },
        'table-auto': { tableLayout: 'auto' },
        'table-fixed': { tableLayout: 'fixed' },
        'text-left': { textAlign: 'left' },
        'text-center': { textAlign: 'center' },
        'text-right': { textAlign: 'right' },
        'text-justify': { textAlign: 'justify' },
        underline: { textDecoration: 'underline' },
        'line-through': { textDecoration: 'line-through' },
        'no-underline': { textDecoration: 'none' },
        uppercase: { textTransform: 'uppercase' },
        lowercase: { textTransform: 'lowercase' },
        capitalize: { textTransform: 'capitalize' },
        'normal-case': { textTransform: 'none' },
        transform: {
            '-TransformTranslateX': '0',
            '-TransformTranslateY': '0',
            '-TransformRotate': '0',
            '-TransformSkewX': '0',
            '-TransformSkewY': '0',
            '-TransformScaleX': '1',
            '-TransformScaleY': '1',
            transform: 'translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))'
        },
        'transform-none': { transform: 'none' },
        'select-none': { userSelect: 'none' },
        'select-text': { userSelect: 'text' },
        'select-all': { userSelect: 'all' },
        'select-auto': { userSelect: 'auto' },
        'align-baseline': { verticalAlign: 'baseline' },
        'align-top': { verticalAlign: 'top' },
        'align-middle': { verticalAlign: 'middle' },
        'align-bottom': { verticalAlign: 'bottom' },
        'align-text-top': { verticalAlign: 'text-top' },
        'align-text-bottom': { verticalAlign: 'text-bottom' },
        visible: { visibility: 'visible' },
        invisible: { visibility: 'hidden' },
        'whitespace-normal': { whiteSpace: 'normal' },
        'whitespace-no-wrap': { whiteSpace: 'nowrap' },
        'whitespace-pre': { whiteSpace: 'pre' },
        'whitespace-pre-line': { whiteSpace: 'pre-line' },
        'whitespace-pre-wrap': { whiteSpace: 'pre-wrap' },
        'break-normal': { overflowWrap: 'normal', wordBreak: 'normal' },
        'break-words': { overflowWrap: 'anywhere' },
        'break-all': { wordBreak: 'break-all' },
        truncate: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        'tabular-nums': { fontVariantNumeric: 'tabular-nums' },
        'outline-offset-0': { outlineOffset: '0px' },
        'outline-offset-1': { outlineOffset: '1px' },
        'outline-offset-2': { outlineOffset: '2px' },
        '-outline-offset-2': { outlineOffset: '-2px' },
        '-outline-offset-1': { outlineOffset: '-1px' },
        'outline-width-1': { outlineWidth: '1px' },
        'outline-width-2': { outlineWidth: '2px' },
        'outline-none': { outlineStyle: 'none' },
        'outline-solid': { outlineStyle: 'solid' },
        'outline-dashed': { outlineStyle: 'dashed' },
        'outline-dotted': { outlineStyle: 'dotted' },
        'outline-double': { outlineStyle: 'double' },
        'outline-hidden': { outlineStyle: 'hidden' },
        'line-clamp-1': { overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: '1' },
        'line-clamp-2': { overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: '2' },
        'line-clamp-3': { overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: '3' },
        'line-clamp-4': { overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: '4' },
        'line-clamp-5': { overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: '5' },
        'line-clamp-6': { overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: '6' },
        'line-clamp-none': {
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 'unset'
        }
    }
};
